<template>
	<v-container>
		<v-card flat color="transparent">
			<v-card-title class="ml-0">
				<v-btn
					icon
					tile
					outlined
					text
					large
					class="mt-n2 ml-n4 rounded-lg"
					@click="$router.go(-1)"
				>
					<v-icon>
						mdi-chevron-left
					</v-icon>
				</v-btn>

				<h1 class="ml-4 text-headline">
					Edit My Profile
				</h1>

				<v-spacer></v-spacer>
			</v-card-title>
		</v-card>

		<v-card :color="`${ant}`" min-height="600px" class="mt-5" flat>

			<v-card-text>
				<v-row>
					<v-col>
						<v-list-item v-if="session">
							<v-list-item-avatar size="80" color="grey">
								<img
									:src="avatarURl"
									:alt="session.writer.nickname"
									v-if="avatarURl"
								/>
								<span v-else class='text-h3'>  {{ session.writer.nickname ? trimFirtTwo(session.writer.nickname) :  session.writer.id  }}</span>
							</v-list-item-avatar>
              <v-list-item-content class="mt-3">
								<v-list-item-title class="headline"> 
                  <v-btn color="red" v-if="avatarURl" :loading="loading" @click="deleteAvatar">
										<i class="far fa-trash-alt white--text"></i>
										<span class="ml-3">Delete Photo</span>
									</v-btn>
									<v-btn :color="primaryBlue" @click="show=true" v-else>
										<v-icon>mdi-upload</v-icon>
										<span class="ml-3">Upload Photo </span>
									</v-btn>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-col>
					<v-col>
						<v-alert :type="actionClass" dismissible v-if="message" @input="alertInput">
							{{ message }}
						</v-alert>
						<div class="mt-4">
							<label for="" class="">Nickname:</label>
							<v-text-field
							dense
							outlined
							v-model="nickname"
							:error-messages="error.nickname"
							@blur="update"
							>
							</v-text-field>
						</div>
					</v-col>
				</v-row>
        <v-divider class="mt-5"></v-divider>
			</v-card-text>

      <v-card-text class="">
							<label for="" class="">About me (short):</label>
							<v-text-field
							dense
							outlined
							v-model="short_about"
							:error-messages="error.short_about"
							@blur="updateAboutMeShort"
              counter
              maxlength="65"
							>
							</v-text-field>
      </v-card-text>

      <v-card-text class="mt-n5">
							<label for="" class="">About me (detailed):</label>
							<v-textarea
							dense
							outlined
							v-model="long_about"
							:error-messages="error.long_about"
							@blur="updateAboutMeLong"
              counter
              auto-grow
              multi-line
              maxlength="5000"
							>
							</v-textarea>
      </v-card-text>
      <v-card-text class="mt-n8">
        <v-row>
					<v-col cols=4>
						<div class="mt-4">
							<label for="" class="">ACADEMIC DEGREE:</label>
							<v-select
							dense
							outlined
							v-model="academic_level"
							:error-messages="error.academic_level"
              :items="levels"
							>
							</v-select>
						</div>
					</v-col>
          <v-col></v-col>
				</v-row>
      </v-card-text>
		</v-card>
    <UploadModal :show="show" @close="show=false"/>
	</v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import colorMxn from '@/mixins/colorMxn';

export default {
	name: 'EditProfile',
	mixins: [colorMxn],
  components: {
    UploadModal: () => import('@/modules/Profile/components/uploadModal'),
	},
	data() {
		return {
			nickname: 'Misiko',
      avatar: null,
			session: null,
			actionClass: 'success',
			message: "",
			error: {},
      show: false,
      loading: false,
      levels: ['Diploma', "Bachelor's", "Master's", "Docrate"],
      academic_level: "Docrate",
      long_about: '',
      short_about: '',
		}
	},
	computed: {
		...mapGetters(['getSession', 'getErrors']),
    avatarURl() {
      return this.avatar;
    },
	},
	watch: {
    getErrors(val) {
      this.error = val;
    },
    getSession(val) {
      this.nickname = val.writer.nickname ? val.writer.nickname : val.writer.id;
      this.avatar = val.writer.avatar;
    }
  },
	mounted() {
		const session = this.getSession
		this.session = session;
		this.nickname = session.writer.nickname ? session.writer.nickname : session.writer.id;
    this.avatar = session.writer.avatar;
    this.long_about = session.writer.long_about ? session.writer.long_about : '';
    this.short_about  = session.writer.short_about ? session.writer.short_about : '';
	},
	methods: {
		...mapActions(['performPutActions', 'refreshAuthToken',]),
		async update() {
			this.error = '';
			const session = this.getSession;
			const payload = {
				nickname: this.nickname,
			}
			
			const fullPayload = {
				params: payload,
				endpoint: `/profile/update-writer/${session.writer.id}`
			}

			const response = await this.performPutActions(fullPayload);
			this.message = response.message;
			this.actionClass = response.status ? "success" : "error";
			if (response.status) {
				await this.refreshAuthToken();
			}
			
		},
    async updateAboutMeLong () {
			this.error = '';
			const session = this.getSession;
			const payload = {
				long_about: this.long_about,
			}
			
			const fullPayload = {
				params: payload,
				endpoint: `/profile/update-writer/${session.writer.id}`
			}

			const response = await this.performPutActions(fullPayload);
			this.message = response.message;
			this.actionClass = response.status ? "success" : "error";
			if (response.status) {
				await this.refreshAuthToken();
			}
			
		},
    async updateAboutMeShort () {
			this.error = '';
			const session = this.getSession;
			const payload = {
				short_about: this.short_about,
			}
			
			const fullPayload = {
				params: payload,
				endpoint: `/profile/update-writer/${session.writer.id}`
			}

			const response = await this.performPutActions(fullPayload);
			this.message = response.message;
			this.actionClass = response.status ? "success" : "error";
			if (response.status) {
				await this.refreshAuthToken();
			}
			
		},
    async deleteAvatar() {
      this.loading = true;
      const session = this.getSession;
			const payload = {
				avatar: null,
			}
			
			const fullPayload = {
				params: payload,
				endpoint: `/profile/update-writer/${session.writer.id}`
			}

			const response = await this.performPutActions(fullPayload);
			this.message = response.message;
			this.actionClass = response.status ? "success" : "error";
      this.loading = false;
			if (response.status) {
        this.avatar = null;
				await this.refreshAuthToken();
			}
    },
		trimFirtTwo (val) {
			const trimmed = val.match(/.{1,2}/g)[0];
			return trimmed.toUpperCase();
		},
		alertInput() {
			this.message = "";
		},
	}
}
</script>